import React from "react";

const ViewLocationInfo = (props) => {
  //console.log({ props });

  return (
    <div className="card mb-2">
      <div className="card-header">
        <h4 className="mb-0">Location Info</h4>
      </div>
      <div className="card-body">
        <div class="row row-cols-1">
          <div class="col-4">
            <div className="row">
              <p className="fw-semibold col-6">Location Details :</p>
              {props?.employerJobLocationsList?.map((location) => (
                <>
                  <label htmlFor="Location Name">
                    {location?.locationName}
                  </label>
                  <label htmlFor="Address">{location?.streetAddress}</label>
                  <label htmlFor="City">{location.city}</label>
                  <label htmlFor="State">{location?.stateName}</label>
                  {/* <div className="col-lg-4 col-md-4">
                                        <label className="form-label">Country</label>
                                        <label htmlFor="Country">{location?.country}</label>
                                    </div> */}
                </>
              ))}
            </div>
          </div>
          <div class="col-4">
            <div className="row">
              <p className="fw-semibold col-6">Contact Persons :</p>
              {
                <label htmlFor="Location Name">
                  {props?.contactList
                    ?.map((contact) => contact.name)
                    .join(", ")}{" "}
                </label>
              }
            </div>
          </div>
          <div class="col-4">
            <div className="row">
              <p className="fw-semibold col-6">Approval Users:</p>
              {
                <label htmlFor="Location Name">
                  {props?.approverList
                    ?.map((contact) => contact.name)
                    .join(", ")}
                </label>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewLocationInfo;
